import { TriggerType } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';

export interface InactivityRequiredIfSelectedRuleDto {
  selectedTriggers?: TriggerType[];
  inactivity?: number;
}

export const InactivityRequiredIfSelectedRuleKey = 'inactivityRequired';

export const InactivityRequiredIfSelectedRule = (dto: InactivityRequiredIfSelectedRuleDto): DomainRule => {
  if (dto.selectedTriggers?.find(s => s === TriggerType.Inactivity) && !dto.inactivity) {
    return {
      result: 'fail',
      ruleKey: InactivityRequiredIfSelectedRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
